import React, { Component, RefObject } from "react"
import LayoutSelector from "../Components/LayoutSelector"
import SizeSlider from "./SizeSlider"
import { constants } from "@albelli/photoselector"

interface FiltersProps {
  store: any
  disableDefault?: boolean
  children?: any
}

interface FiltersState {
  sortingDropdown: boolean
  layoutDropdown: boolean
  yearDropdown: boolean
  monthDropdown: boolean
}

class Filters extends Component<FiltersProps, FiltersState> {
  private ref: RefObject<HTMLDivElement> = React.createRef()

  constructor(props: FiltersProps) {
    super(props)

    this.state = {
      sortingDropdown: false,
      layoutDropdown: false,
      yearDropdown: false,
      monthDropdown: false
    }
  }

  setDropdown({ sortingDropdown = false, layoutDropdown = false, yearDropdown = false, monthDropdown = false }) {
    this.setState({ sortingDropdown, layoutDropdown, yearDropdown, monthDropdown })
  }

  render() {
    const { disableDefault, store } = this.props

    const children = React.Children.map(this.props.children, (child) => {
      if (child) {
        return React.cloneElement(child, {
          dropdowns: this.state,
          setDropdown: this.setDropdown.bind(this)
        })
      }
    })

    return (
      (window.innerWidth > constants.mobileWidth || this.props.children) && (
        <div className="photoselector-photoorganiser-filter-container" ref={this.ref}>
          {children}
          {disableDefault ? null : <LayoutSelector store={store} />}
          {disableDefault ? null : <SizeSlider store={store} />}
        </div>
      )
    )
  }
}

export default Filters
